import React from 'react';
import WName, {WArticle} from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../../ormaybe/OrMaybeLink';
import LRL from '../LongReadLink';
import {E1, E2, TLDR, Qual} from '../../common';

// ‘’ … –

// OLD NOTE
// forgot something about it needing a 'control centre'
// this tied into a bigger concept

// Much of humanity can be explained by reactivity vs. conscious AGENCY
export const reactivity = {
  name: "reactivity",
  alternatives: "reactive,r",
  parentName: "reactivity",
  prelude: <span>
    Who doesn’t love an <PL name="comprehensive">all-encompassing</PL> ‘<QL>Weltanschauung</QL>’ that makes <PL>sweeping</PL> <QL name="definitive">generalisations</QL> about (<Qual.basically />) <i><LRL name="scope">everything</LRL></i>?<sup>†</sup>
  </span>,
  header: <span>
    A great many things can be explained<sup>(2)</sup> by <i>reacticity</i>.
  </span>,
  headerFootnote: <p>
    † That was <OML name="offensive">sarcasm</OML>.
  </p>,
  preview: <div className="long-read-preview">
    <p><TLDR />: if we accept that <PL name="sweeping">a lot</PL> (<Qual.probably /> the majority) of <QL>humans</QL> are not actively using their conscious <i><NW>agency</NW></i> (i.e., <NW>entropy</NW>-<LRL name="notions">fighting</LRL> ability) – i.e., ‘<AL>sleeping</AL>’ – then a <PL name="sweeping">whole bunch</PL> of <LRL name="gaiacentrism">Earth</LRL>’s <i><AL name="dysfunctional">problems</AL></i> can be <PL name="reductionist">easily</PL> <E2 suffix="ed" italic />. Maybe our <QL name="unity">conscious</QL> ‘<QL>body</QL>’ (at least on <LRL name="gaia">Earth</LRL>) needs some non-<NW word="ig">individually-greedy</NW> <i><OML name="authoritarianiam">brain</OML></i> ‘<QL name="body.">cells</QL>’.</p>
    <p style={{color: "red"}}>[Under conscruction still]</p>
  </div>,
  text: <div className="long-read-text">
    <p>Old note found in the JS doc: (This <QL>website</QL> is, incidentally, written with a computer coding frameword called ‘React’. Because, you know, irony.)</p>
    <pre>{String.raw`// OLD NOTE
// forgot something about it needing a 'control centre'
// this tied into a bigger concept`}</pre>
    <p>Obviously it ties into the <PL>human-standard</PL> need for <PL>hierarchy</PL> (well-order the non-finite: everything <OML name="offensive">mustustust have a PLAYCE</OML>.</p>
    <p>[Incomplete; probably <PL name="rule them all"><i>this</i> AshEejitDurbatulûk</PL> is too <i>weak</i> (cf. ‘drained’) to ever fix it.]</p>
  </div>,
  sublist: [

  //NATURE!!!!!!!!!111
  {
  name: "nature",
  alternatives: "natural",
  header: <span>
    ‘Nature’ is just a word for PureReactivity<sup>®</sup>
  </span>,
  preview: <div className="long-read-preview">
    <p>Okay, it might not <QL name="tm">come with an ®</QL>, but ‘nature’ does not strive for <NW word="overcome">Ganzesystemüberwindung</NW> (cf. <QL name="pratty.maxims">usiache kujitahidi</QL>). ‘Nature’ cannot <NW word="overcome">Ganze-system-überwinden</NW> because <i>is</i> the ganze <AL>System</AL> (whole <PL name="ick.">system</PL>).</p>
    <p>2020’s ‘<PL name="ourself">science</PL>’ is mostly Pure<sup>®</sup> <NW>conservative thinking</NW> with no room for <NW>God</NW>. <WName cap ic/> <AL name="fields.">science</AL> <PL name="comprehensive">has room</PL> for It; and yes, <NW>God</NW> is not He<sup>(™)</sup> and not something OutThere<sup>®</sup> (cf. the <NW>FOE</NW>) that supervenes on a frankly <AL name="fields.logic">illogical</AL> lower-‘<NW>level</NW>’ that is non-<AL name="notnew.p.popper">falsifiable</AL>.</p>
  </div>,
  text: <div className="long-read-text">
    <p>‘Nature’ is beautiful in the way that the (<NW word="poiocentrism">)poiocentrically</NW>-named) <QL>Fibonacci</QL> sequence is beautiful. If our <QL>salvation</QL> is <QL name="salvation.">actually thinking</QL>, ‘nature’ does not think. It <i>reacts</i>.</p>
    <p>‘Nature’ is 100% bound by the laws of thermodynamics. The <LRL>imaginattrion</LRL> is not.</p>
    <p>Proof of that: it is possible to <i><LRL>imagine</LRL></i> a universe in which entropy does not lways increase because we find a way to ‘<NW>coalesce</NW>’ as <QL name="unity.answer">one</QL> <LRL name="scope">universe</LRL> and <i>consciously</i> (<QL name="salvation.">actually thinking</QL>) generate energy from quantum fluctuation to walk the मध्यमक (Madhyamaka: middle way) between too <i>much</i> (Big Crunch/collapse) and not <i>enough</i> (dispersal/<NW word="heatdeath">heat death</NW>).</p>
    <p>[under construction]</p>
  </div>,

  },

  ],
};
